import $store from '@/store'

import { checkRole } from '@/utils/acl'

export default {
  /**
   * Removes an element from the DOM if the user does not have a specific role
   * @param {object} el actual DOM element
   * @param {string[]} validRoles a list of allowed roles
   * @param {object} vNode Vue virtualized DOM element
   * @public
   */
  inserted(el, { value: validRoles }, vNode) {
    if (!validRoles || !validRoles.length) return
    const userRole = $store.getters['session/role']
    if (checkRole(userRole, validRoles)) return
    vNode.elm.parentElement.removeChild(vNode.elm)
  },
}
